import { Component } from '@angular/core'
import { FormBuilder } from '@angular/forms'
import { Store } from '@ngrx/store'
import { Actions } from '@ngrx/effects'
import { AutomationEventTypes, AutomationTypes } from '@tokeet-frontend/automations'
import { AutomationWizardPanelBaseComponent } from '@tv3/containers/automations/automations-wizard/automation-wizard-panel.component'
import { guestSecurityDepositNotificationMessages } from './messages'

@Component({
  selector: 'app-security-deposit-automation-wizard',
  templateUrl: './security-deposit-automation-wizard.component.html',
  styleUrls: ['./security-deposit-automation-wizard.component.scss'],
})
export class SecurityDepositAutomationWizardComponent extends AutomationWizardPanelBaseComponent {
  type = AutomationTypes.SecurityDeposit

  guestNotificationMessages = guestSecurityDepositNotificationMessages

  constructor(protected actions: Actions, protected fb: FormBuilder, protected store: Store<any>) {
    super(actions, store, fb)
    this.form.patchValue({ event: AutomationEventTypes.SecurityDepositCreated })
  }
}
